import { render, staticRenderFns } from "./price-overrides-upload.vue?vue&type=template&id=1d8f6c6e&scoped=true"
import script from "./price-overrides-upload.vue?vue&type=script&lang=js"
export * from "./price-overrides-upload.vue?vue&type=script&lang=js"
import style0 from "./price-overrides-upload.vue?vue&type=style&index=0&id=1d8f6c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f6c6e",
  null
  
)

export default component.exports